/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { getCellStatus } from '../../utils/FormatFunctions';
import { SelectFilter } from '../../components/inputs/filters/select';

export function StudentsPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/children`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { requestApi: reqApiTeam, data: dataTeam } = useFetch(`${baseApiUrl}/teams`);
  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'name', label: 'Nome' },
    { name: 'team.name', label: 'Turma' },
    { name: 'status', label: 'Status' },
  ];

  useEffect(() => {
    reqApiTeam('get');
  }, []);

  return (
    <Box>
      <PageTitle>Alunos</PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate
        loading={loading}
        rowActions={{ show: false, edit: true, delete: true }}
        formatColum={[
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
          {
            name: 'team_id',
            filterComponent: SelectFilter,
            placeholder: 'Selecionar instituição',
            isSearchable: true,
            onInputChange: value => {
              reqApiTeam('get', { params: { search: value } });
            },
            options: [
              ...(dataTeam?.data?.map(item => ({
                label: item?.name,
                value: item?.id,
              })) ?? []),
            ],
          },
        ]}
      />
    </Box>
  );
}
